import { createTheme } from '@mui/material/styles';
import { LAYOUT_CONTENT_BG, LAYOUT_SURFACE } from './layout/layoutColors';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0ea5e9',
    },
    secondary: {
      main: '#64748b',
    },
    background: {
      default: LAYOUT_CONTENT_BG,
      paper: LAYOUT_SURFACE,
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(15, 23, 42, 0.08)',
        },
      },
    },
  },
});

export default theme;
